import { Box, Text, Wrap, WrapItem } from "@chakra-ui/react";
import { teamMembers } from "../../constants/team-members";
import { useContaxt } from "../../context/Context";
import { HeadLine } from "../HeadLine";
import { ContentCard } from "./ContentCard";

export function Team({ componentRef }) {
  const { variant } = useContaxt();

  return (
    <>
      <Box
        w={"100%"}
        bg={"#1D1D25"}
        ref={componentRef}
        id={"team"}
        pt={"40px"}
        pb={"60px"}
      >
        <HeadLine
          as="h1"
          text={
            <Text color="white" fontWeight={"bold"}>
              Das Team
            </Text>
          }
        />
        <Wrap
          justify={"center"}
          mt={"50px"}
          spacing={["16px", "16px", "24px", "32px"]}
        >
          {teamMembers().map((person, i) => {
            return (
              <WrapItem key={i}>
                <ContentCard
                  image={person?.Image}
                  alt={person.alt}
                  title={person.title}
                  text={person.text}
                  aspectRatio={10 / 7}
                />
              </WrapItem>
            );
          })}
        </Wrap>
      </Box>
    </>
  );
}
